<template>
  <div
    class="w-full md:max-w-375px flex aspect-square bg-cover bg-no-repeat bg-center flex-shrink-0 relative"
  >
    <image-kit
      :path="user?.profilePicture || 'placeholder.png'"
      width="375"
      height="375"
      :alt="`Connect ${user?.firstName} ${user?.lastName}`"
      additionalClasses="object-cover"
      class="w-full"
    />
    <div
      class="w-full absolute -bottom-px left-0 right-0 h-190px rotate-180 img-gradient"
    />
  </div>
</template>

<script setup lang="ts">
import type { User } from "@/types/user";
import type { PropType } from "vue";
import ImageKit from "@/components/imagekit/ImageKit.vue";

const props = defineProps({
  user: {
    type: Object as PropType<User>,
  },
});
</script>

<style scoped>
.profilePic,
.img-gradient {
  background: linear-gradient(180deg, #050505 0%, rgba(5, 5, 5, 0) 100%);
}

@media screen and (min-width: 768px) {
  .profilePic,
  .img-gradient {
    background: linear-gradient(180deg, #111113 0%, rgba(17, 17, 19, 0) 100%);
  }
}

@media screen and (min-width: 1280px) {
  .profilePic,
  .img-gradient {
    background: linear-gradient(180deg, #17171a 0%, rgba(23, 23, 26, 0) 100%);
  }
}
</style>
